import { z } from "zod";

export const nameSchema = () => z.string().max(250);
